import React, { useState } from 'react';
import Hosts from '../../Hosts'
import {reqPOST, passwordHash} from '../../Utils'


import { confirmAlert } from 'react-confirm-alert';
//import { getTokenInfo } from '../../UseToken';

const RecuperarForm = (props) => {
  
  //const [/*companycode,*/ setCompanyCode] = useState('');
  const [password, setPassword] = useState('');
  const [password_conf, setPasswordConf] = useState('');

  const [input_type, setInputType] = useState('password');

  const handleSubmit = e => {

    e.preventDefault();
    localStorage.clear();

    if(password !== '' && password === password_conf) {
      reqPOST(Hosts.SIMCore_API + '/' + props.loginType, {
        companycode: Hosts.companycode,
        //companycode,
        token: 'hashtoken',
        password: passwordHash(password)
      })
      .then(objToken => {
        if (objToken.token !== false) {
          console.log('SETOU->', objToken)
        }
        else {
          confirmAlert({
            title: 'Erro de Recuperação',
            message: 'Dados de acesso incorretos',
            buttons: [
              {
                label: 'Voltar',
                onClick: () => { return }
              }

            ]
          });
          //alert('Não Autenticado');
          localStorage.clear();
          //setToken(token);
        }
      })
    }
    else {
      alert('Palavra-chave de confirmação diferente')
    }
  }

  const togglePwd = async e => {
    if (input_type.localeCompare('text') === 0)
      setInputType('password');
    else
      setInputType('text');
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group assec-mb-0">
        <label>
          <p>Palavra-Passe</p>
          <input type={input_type} className="form-input input-pwd" value={password} onChange={(e) => setPassword(e.target.value)} />
          <img alt='' onClick={togglePwd} src={'./img/view_password.svg'} />
        </label>
      </div>
      <div className="form-group assec-mb-0">
        <label>
          <p>Confirmação Palavra-Passe</p>
          <input type={input_type} className="form-input input-pwd" value={password_conf} onChange={(e) => setPasswordConf(e.target.value)} />
          <img alt='' onClick={togglePwd} src={'./img/view_password.svg'} />
        </label>
      </div>
      
      <div className="form-group">
        <button className="form-button btn-primary" type="submit">Entrar</button>
      </div>
    </form>
  );


}

/*
RecuperarForm.propTypes = {
    setToken: PropTypes.func.isRequired
  };
*/

export default RecuperarForm;
